import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { NumberField, RadioGroupOption } from 'components/Form'
import {
  AbTestTrafficSplitType,
  abTestTrafficSplitTypes,
} from 'features/ab-tests/types/abTestTrafficSplit'
import { AbTestsCommonSchema } from '../abTestsCommonSchema'

type Props = {
  disabled: boolean
}

export const useTrafficSplitTypeOptions = ({ disabled }: Props): RadioGroupOption[] => {
  const { t } = useTranslation('features/abTests', { keyPrefix: 'common.basicAttributes' })
  const { control } = useFormContext<AbTestsCommonSchema>()

  const SubForm: React.JSX.Element = (
    <NumberField
      control={control}
      disabled={disabled}
      label={t('cookieLifetime.label')}
      name='cookieLifetime'
      tooltip={{ content: t('cookieLifetime.tooltip') }}
    />
  )

  return abTestTrafficSplitTypes.map(
    (trafficSplitType: AbTestTrafficSplitType): RadioGroupOption => ({
      label: t(`trafficSplitType.values.${trafficSplitType}`),
      onSelectedContent: trafficSplitType === 'localStorage' ? SubForm : undefined,
      value: trafficSplitType,
    }),
  )
}
